import script from "./PlaceSearchBox.vue?vue&type=script&setup=true&lang=js"
export * from "./PlaceSearchBox.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__